export enum TipoDistribuidora {
  SAESA = 'S',
  EDELAYSEN = 'E',
  LUZ_OSORNO = 'L',
  FRONTEL = 'F',
}
